import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label-number-1" }, " ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-11" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, "Closing")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}